/* A skill folder's rules as the API's checker holds them (backend/modules/skills/business/folder.py):
   its limits, the name's pattern, and the code of each refusal (backend/errors/README.md).
   In `shared/`, not `features/skills`, because the fake checker in `shared/mocks` reads them
   too, and nothing in `shared/` imports a feature. */

export const NAME_MAX = 64;
export const DESCRIPTION_MAX = 1024;
/** Lowercase letters and digits, single hyphens between them. */
export const NAME_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const MAX_FILE_BYTES = 5 * 1024 * 1024;
export const MAX_FILES = 500;
export const MAX_FOLDER_BYTES = 20 * 1024 * 1024;

/** `refused` is the 422 itself; from `noSkillMd` to `archiveUnreadable`, the codes of the
    problems it lists in `details`. The rest are refusals of their own. */
export const SKILL_CODES = {
  refused: 3170005,
  noSkillMd: 3170006,
  badName: 3170007,
  badDescription: 3170008,
  bigFile: 3170009,
  manyFiles: 3170010,
  bigFolder: 3170011,
  unsafePath: 3170012,
  badFrontmatter: 3170013,
  nameTaken: 3170014,
  archiveUnreadable: 3170015,
  changed: 3170016,
  inUse: 3170017,
  githubMissing: 3170018,
  githubBadLink: 3170019,
  githubLimited: 3170020,
  githubTooBig: 3170021,
} as const;
